import React from 'react';
import classNames from 'classnames';
import './FooterArrow.css';

type Props = {
  onClick?: (ev: React.MouseEvent) => void;
  className?: string;
};

const FooterArrow = ({ onClick, className }: Props) => (
  <svg
    className={classNames('footer-arrow', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 24 24"
    onClick={onClick}
  >
    <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z" />
  </svg>
);

export default FooterArrow;
